angular.module('nv.my-supports').controller('MySupportsListCtrl', MySupportsListCtrl);

function MySupportsListCtrl($state, AttendanceRecord, SpinnerModal, StudentSupport, SupportAttendanceService, Rollbar) {
  const self = this;

  self.mySupports = [];

  self.goToSupportOverview = supportId => {
    SpinnerModal.activateSpinner(`Loading support data...`);
    $state.go('main.school.support-overview', { supportId });
  };

  self.getAttendanceRateString = function(summary) {
    if (!summary) return 'na';
    return summary.percentPres + summary.percentLate + '%';
  };

  self.getAttOnTrackStatus = function(summary) {
    if (!summary) return true;
    return summary.percentPres + summary.percentLate >= 80;
  };

  self.$onInit = function() {
    if (self.activeSupportsForCurrentUser) {
      // For each support, fetch both attendance records and studentSupports
      self.activeSupportsForCurrentUser.forEach(function fetchSupportData(support) {
        const supportId = support._id;

        const mySupportRow = {
          _id: supportId,
          name: support.name,
          leadHumanName: support.getLeadHumanName(),
          frontendStatus: support.getFrontendStatus(),
          isCompleted: support.getFrontendStatus() === 'COMPLETED',
          sortOrderBasedOnFrontendStatus: support.getSortOrderBasedOnFrontendStatus(),
          category: support.getCategoryHumanName(),
          attendanceSummary: 'loading...',
          activeStudentCount: 'loading...',
        };

        AttendanceRecord.queryBySupportId(supportId)
          .$promise.then(function summarizeAttendanceRecords(attRecords) {
            // Get attendance summary by supportId & append to support
            const summarized = SupportAttendanceService.summarizeAttendanceData(attRecords, 'supportId')[0];
            mySupportRow.attendanceSummary = summarized;
          })
          .catch(err => {
            Rollbar.error(`Unable to get summarize attendance data for: ${supportId} `, err);
          });

        StudentSupport.queryBySupportId(supportId)
          .$promise.then(function countStudentSupports(studentSupports) {
            const enrollments = StudentSupport.getActiveAndCompletedStudentSupports(studentSupports).length || 0;
            mySupportRow.activeStudentCount = enrollments;
          })
          .catch(err => {
            Rollbar.error(`Unable to get count of active student supports for supportId: ${supportId} `, err);
          });

        self.mySupports.push(mySupportRow);
      });
    }
    self.mySupports = _.sortBy(self.mySupports, function(support: any) {
      return support.sortOrderBasedOnFrontendStatus;
    });

    SpinnerModal.deactivateSpinner();
  };
}
